import {
  NBS_API_CHECK_USERNAME_REQUEST,
  NBS_API_CHECK_USERNAME_SUCCESS,
  NBS_API_CHECK_USERNAME_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiCheckUsernameRequest (fromPage) {
  return { type: NBS_API_CHECK_USERNAME_REQUEST, fromPage };
}
function nbsApiCheckUsernameSuccess (response) {
  return {
    type: NBS_API_CHECK_USERNAME_SUCCESS,
    response
  };
}
function nbsApiCheckUsernameError (error) {
  return {
    type: NBS_API_CHECK_USERNAME_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiCheckUsername (data, fromPage) {
  const url = 'checkUsername';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiCheckUsernameRequest(fromPage));
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiCheckUsernameSuccess(response)))
      .catch(error => dispatch(nbsApiCheckUsernameError(error)));
  };
}
